export const getSpiideoVenueLabel = (stadium) => {
    if (!stadium) return '';

    const cityName = stadium.city?.name;
    const stadiumId = stadium.id;
    const stadiumName = stadium.name;

    return cityName ? `${stadiumName} - ${cityName} (${stadiumId})` : `${stadiumName} (${stadiumId})`;
};
